export class CentreModel {
    public id: string;
    public code: string;
    public name: string;
    public subTilte: string;
    public address1: string;
    public address2: string;
    public address3: string;
    public address4: string;
    public countryId: string = null;
    public tel: string;
    public fax: string;
    public email: string;
    public reportEmail: string;
    public web: string;
    public contact: string;
    public custom1: string;
    public custom2: string;
    public custom3: string;
    public custom4: string;
    public bankName: string;
    public bankAddress: string;
    public bankSortCode: string;
    public bankAccount: string;
    public accountName: string;
    public bankSwifCode: string;
    public iban: string;
    public timeZoneId: string;
    public currencyId: string = null;
    public groupId: string = null;
    public newGroup: string;
    public vatId: any[];
    public active: boolean;
    public isClinicLogoDelete: boolean;
    public clinicLogoName: string;
    public isSignatureDelete: boolean;
    public signatureName: string;
    public associatedClinic : boolean;
}

export class CentreListModel {
  constructor(id: string,
    name: string,
    addresses: any[],
    tel: string,
    group: string,
    active: boolean) {
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/centre/centre.model.ts